import { Box, Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { useState } from "react";
import { Control } from "react-hook-form";
import { BiEdit, BiPlus } from "react-icons/bi";
import Field from "../Field";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { Modal } from "antd";
import FormAdicionarContas from "./FormAdicionarContas";
import { RateioForm } from "core/features/rateio/typings";
import OutlineButton from "ui/components/Button/OutlineButton";
import { showConfirm } from "infra/helpers/alerta";
import useFecharRateio from "core/features/rateio/hooks/useFecharRateio";
import { ContaItemBase } from "core/features/conta/typings";

interface FormRateioHeaderProps {
  rateioId: string;
  year: string;
  month: string;
  rateioAberto?: boolean;
  onCloseRateio?: () => any;
  contasRateio?: ContaItemBase[];
  control: Control<RateioForm, object>;
  enabledEdit: boolean;
  onEnableEdit: () => any;
  refetchContas: () => Promise<any>;
  loading?: boolean;
}

function FormRateioHeader({
  rateioId,
  year,
  month,
  rateioAberto = true,
  onCloseRateio,
  contasRateio = [],
  control,
  enabledEdit,
  onEnableEdit,
  refetchContas,
  loading,
}: FormRateioHeaderProps) {
  const { mutate: fecharRateio, isLoading: isLoadingFecharRateio } =
    useFecharRateio({
      id: rateioId,
      year,
      month,
      onSuccess: () => {
        refetchContas();
        onCloseRateio?.();
      },
    });
  const [isOpenModal, setIsOpenModal] = useState(false);

  if (loading || isLoadingFecharRateio) {
    return <Text>Carregando...</Text>;
  }

  return (
    <>
      {isOpenModal ? (
        <Modal
          centered
          visible={isOpenModal}
          footer={null}
          destroyOnClose
          onCancel={() => setIsOpenModal(false)}
          closable={false}
          width={"max(900px, 60vw)"}
          bodyStyle={{
            // height: "max(95vh, 450px)",
            overflow: "auto",
            paddingBottom: 16,
          }}
        >
          <FormAdicionarContas
            rateioId={rateioId}
            year={year}
            month={month}
            onClose={() => setIsOpenModal(false)}
            onSuccess={async () => {
              setIsOpenModal(false);

              await refetchContas();
            }}
          />
        </Modal>
      ) : null}

      <Box w="200px">
        <Field
          control={control}
          name="nome"
          rules={{ required: true }}
          inputProps={{
            disabled: !enabledEdit,
            placeholder: "Nome do rateio",
            fontWeight: "bold",
            fontSize: 18,
            width: "200px",
            textDecoration: "underline",
            borderColor: "#00000000",
            _disabled: {
              background: "none !important",
              pointerEvents: "none",
            },
          }}
        />
      </Box>

      <Box mx={4} mt="7px">
        <BiEdit
          color={colors.primary}
          size={24}
          onClick={onEnableEdit}
          cursor="pointer"
          aria-label="Editar rateio"
          aria-roledescription="Botão de editar rateio"
          style={{ marginTop: "auto", marginBottom: "auto" }}
        />
      </Box>

      {!rateioAberto ? (
        <Text
          fontSize={16}
          ml={"auto"}
          fontWeight="500"
          alignSelf="center"
          noOfLines={1}
        >
          Rateio fechado
        </Text>
      ) : (
        <Flex flex={1} justifyContent="flex-end">
          <PrimaryButton
            onClick={() => setIsOpenModal(true)}
            justifyContent="center"
          >
            <Flex alignItems="center">
              <BiPlus size={20} color={colors.white} />
              <Text fontSize={13} color={colors.white} ml={2} fontWeight="400">
                Adicionar contas
              </Text>
            </Flex>
          </PrimaryButton>

          <OutlineButton
            disabled={!contasRateio.length}
            onClick={() =>
              showConfirm(
                "Deseja fechar esse rateio? Não será mais possível adicionar ou remover contas"
              ).then(({ isConfirmed }) => {
                if (isConfirmed) {
                  fecharRateio(rateioId);
                }
              })
            }
            ml={4}
          >
            Fechar rateio
          </OutlineButton>
        </Flex>
      )}
    </>
  );
}

export default FormRateioHeader;
